require.context('../fonts', true);

import '../stylesheets/base';

require('./GC/analytics/kissmetrics.js');

require('./GC/analytics/optimizely.js');

require('./GC/GC-analytics.js');

require('./GC/GC.js');

require('./GC/init.js');

require('./GC/GC-loader.js');

require('metismenu/dist/metisMenu');

require('jquery.smartbanner');